













































import Vue from 'vue';
import { WOW } from 'wowjs';

export default Vue.extend({
	data() {
		return {
			publicPath: process.env.BASE_URL,
			bannerCarouse: 0,
			banners: [
				{
					title: 'Delta Technology Limited',
					text: 'Provide the reliable performance, easy maintenance and outstanding quality for our customers.',
					pic: require('../../static/images/Pic_Banner-1.jpg'),
				},
				{
					title: 'Delta Technology Limited',
					text: 'Provide the reliable performance, easy maintenance and outstanding quality for our customers.',
					pic: require('../../static/images/Pic_Banner-2.jpg'),
				},
			],
			services: [
				{
					title: 'Technical Service Center',
					pic: require('../../static/images/Pic_Services-1.jpg'),
				},
				{
					title: 'Customer Service Management Platform',
					pic: require('../../static/images/Pic_Services-2.jpg'),
				},
				{
					title: 'Technology Center・Service Area・Call Center・Contract Service Provider',
					pic: require('../../static/images/Pic_Services-3.jpg'),
				},
			],
		};
	},
	mounted() {
		this.$nextTick(() => {
			new WOW().init();
		});
	},
});
